import React from "react";

export function Honeypot(props) {
  return (
    <label className="af-hp" aria-hidden="true">
      Оставьте поле пустым
      <input type="text" {...props} className="af-hp" />
    </label>
  );
}
